/* SA LIVE CART PROGRESS — MINIMOG SAFE */

const GOAL_AMOUNT = 1999;

async function updateCartProgressPremium(){

  try{
    const res = await fetch('/cart.js',{cache:'no-store'});
    const cart = await res.json();

    const total = cart.total_price / 100;
    const percent = Math.min((total/GOAL_AMOUNT)*100,100);

    document.querySelectorAll('#sa-cart-progress').forEach(wrapper=>{

      const fill = wrapper.querySelector('.sa-progress-fill');
      const text = wrapper.querySelector('.sa-remaining');

      if(!fill || !text) return;

      /* EMPTY CART FIX */
      if(cart.item_count === 0){
        fill.style.width="0%";
        wrapper.classList.remove('unlocked');
        text.innerHTML=`Add ₹${GOAL_AMOUNT} more to unlock 🔥`;
        return;
      }

      fill.style.width = percent+"%";

      if(total >= GOAL_AMOUNT){
        wrapper.classList.add('unlocked');
        text.innerHTML="🎉 Extra Discount unlocked!";
        fireConfetti(wrapper);
      }else{
        wrapper.classList.remove('unlocked');
        text.innerHTML=
          `Add ₹${Math.round(GOAL_AMOUNT-total)} more to unlock 🔥`;
      }
    });

  }catch(e){
    console.log("Cart progress error",e);
  }
}

/* CONFETTI */
function fireConfetti(wrapper){
  if(wrapper.dataset.confetti) return;
  wrapper.dataset.confetti="1";

  if(window.confetti){
    confetti({
      particleCount:100,
      spread:70,
      origin:{y:0.7}
    });
  }
}

/* MINIMOG EVENTS */
document.addEventListener("product-ajax:added",()=>{
  setTimeout(updateCartProgressPremium,400);
});

document.addEventListener("cart:update",()=>{
  setTimeout(updateCartProgressPremium,400);
});

document.addEventListener("DOMContentLoaded",updateCartProgressPremium);

/* ===============================
   MINIMOG REALTIME CART LISTENER
================================*/

// Listen to Minimog internal cart updates
if (window.MinimogEvents) {

  MinimogEvents.subscribe(
    MinimogTheme.pubSubEvents.cartUpdate,
    function () {
      setTimeout(updateCartProgressPremium, 300);
    }
  );

}

// Fallback watcher (when drawer DOM reloads)
const drawerObserver = new MutationObserver(() => {
  if (document.querySelector('#MinimogCartDrawer')) {
    updateCartProgressPremium();
  }
});

drawerObserver.observe(document.body, {
  childList: true,
  subtree: true
});